import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowShareLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-share-left, back, last, reply"><path d="M1.75 12L11.25 3.75V8.5C19.75 8.5 22.25 11.75 22.25 20.25C20.75 17.25 19.75 15.5 11.25 15.5V20.25L1.75 12Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowShareLeft;
